<template>
    <div id="app">
        <router-view :key="$route.fullPath" />
        <CustomerService></CustomerService>
    </div>
</template>
<script>
import CustomerService from './layout/components/customerService.vue';
export default {
    components: {
        CustomerService,
    },
    name: 'App',
    data() {
        return {
            loading: null,
        };
    },
    mounted() {
        this.getMessage();
        setInterval(() => {
            this.getMessage();
        }, 60 * 1000);
    },
    computed: {
        sign() {
            return this.$store.state && this.$store.state.sign;
        },
    },
    methods: {
        getMessage() {
            if (this.sign) {
                this.$request({
                    url: '/msg/sys_msg/view/sys_msg_num',
                }).then((res) => {
                    const {state, result} = res.data;
                    if (state && result) {
                        this.$store.commit('SET_MSG_NUM', result || null);
                    }
                });
            }
        },
    },
};
</script>
<style lang="scss">
@import '@/assets/css/common.scss';
</style>
